<template>
    <BreadCrumb PageTitle="Ajouter un paiement service" />
    <AddPaiementService />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddPaiementService from "../../components/PaiementService/AddPaiementService.vue";
  
    export default defineComponent({
      name: "AddPaiementServicePage",
      components: {
        BreadCrumb,
        AddPaiementService,
      },
    });
  </script>